import Image from '@tiptap/extension-image'

export type CustomImageAttributes = {
  src: string
  alt: string | null
  title: string | null
  width: string | null
  height: string | null
  link: string | null
}

export const CustomImage = Image.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      width: {
        default: null,
        parseHTML: element => element.getAttribute('width'),
        renderHTML: attributes => {
          if (!attributes.width) return {}
          return { width: attributes.width }
        },
      },
      height: {
        default: null,
        parseHTML: element => element.getAttribute('height'),
        renderHTML: attributes => {
          if (!attributes.height) return {}
          return { height: attributes.height }
        },
      },
      link: {
        default: null,
        // Link is stored as data attribute, not rendered as wrapping <a> in the editor
        renderHTML: () => ({}),
      },
    }
  },
})
